import { ReduceStore } from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import { LightboxUiLockActions } from '../constants/lightbox_ui_lock/lightbox_ui_lock_actions';

class LightboxUiLockStoreClass extends ReduceStore {
    getInitialState() {
        return {
            visible: false,
            loaded: false,
        };
    }

    reduce(state, { source, action }) {
        const { type } = action;

        if (source === ACTION_TYPES.LIGHTBOX_UI_LOCK_ACTION) {
            switch (type) {
                case LightboxUiLockActions.SHOW_ACTION:
                    state.visible = true;
                    state.loaded = true;
                    this.__emitChange();
                    break;

                case LightboxUiLockActions.HIDE_ACTION:
                    if (state.visible) {
                        state.visible = false;
                        state.loaded = false;
                        this.__emitChange();
                    }
                    break;

                case LightboxUiLockActions.LOADING_DONE_ACTION:
                    if (state.loaded) {
                        state.loaded = false;
                        this.__emitChange();
                    }
                    break;
            }
        }

        return state;
    }
}

const LightboxUiLockStore = new LightboxUiLockStoreClass(Dispatcher);
export { LightboxUiLockStore };